<template>
  <div>
    <v-col offset-md="3" :md="6">
      <h1 class="text-center primary--text">Pool Entry</h1>
      <v-select v-model="poolId" @change="poolChange"
        :items="memberPools" item-text="poolName" item-value="poolId"
        label="Select Pool">
      </v-select>
      <v-divider></v-divider>
      <div v-if="poolObject && poolPastEndDate">
        <h2 class="text-center error--text">Entries for this pool has ended</h2>
      </div>
      <div v-else>
        <div v-if="gameEntry  && !copyEntry">
          <div v-if="poolObject && 
            (poolObject.tournamentType == 'L' || 
            poolObject.tournamentType == 'B')"
          >
            <h2 class="text-center primary--text">Game Entry</h2>
            <v-row>
              <v-spacer></v-spacer>
              <v-btn color="success" @click="copyEntry=true" outlined>Copy Entry From Others</v-btn>
              <v-spacer></v-spacer>
            </v-row>
            <h4 class="text-center primary--text">Or Click/Touch on the team to pick your choice</h4>
            <h4 class="text-center primary--text">Clicking on both teams would mean a Draw or a No-Result</h4>
            <v-card v-for="(item, index) in entryList" :key="index" class="my-3 py-2">
              <v-row class="mx-5">
                Game #{{ index + 1 }}
                <v-spacer></v-spacer>
                On {{ convDate(item.gameDate) }} @ {{ item.gameVenue }}
              </v-row>
              <v-row class="mx-10">
                <v-card class="text-center py-2 px-2" 
                  :class="[ (item.resultEntry == 'A' || item.resultEntry == 'X') ? 'primary' : '' ]"
                  @click="selectTeam(index, 'A')">
                  {{ item.memberA }} ({{ item.oddA }})
                </v-card>
                <v-spacer></v-spacer>
                <v-card class="text-center py-2 px-2" 
                  :class="[ (item.resultEntry == 'B' || item.resultEntry == 'X') ? 'primary' : '' ]"
                  @click="selectTeam(index, 'B')">
                  {{ item.memberB }} ({{ item.oddB }})
                </v-card>
              </v-row>
              <div class="mx-16"  v-for="(bon, bIndex) in bonusUsed" :key="bon.bonusId">
                  <v-select v-model="item.bonusEntry[bIndex].entry"
                    :items="bon.possOutcomes" :label="bon.bonusName"
                    class="mx-16 mb-n3"
                  >
                  </v-select>
              </div>
            </v-card>
          </div>
          <div v-else-if="poolObject">
            <h4 class="text-center primary--text">Click on Next</h4>
          </div>
          <v-row v-if="poolObject" class="my-6 mx-2">
            <v-btn color="success" outlined @click="goBack">Cancel</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" outlined @click="saveGames">Save</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" outlined @click="gameNext">Next</v-btn>
          </v-row>
        </div>
        <div v-else-if="!copyEntry">
          <h2 class="text-center primary--text my-3">Enter Tournament Knockout Qualifiers</h2>
          <h3 class="text-center primary--text">Choose {{ koValues[koIndex] }}</h3>
          <h3 class="text-center primary--text">{{ koQList.length }} out of {{ koNumbers[koIndex] }} chosen</h3>
          <v-card v-for="item in tourGroups[0].groupMembers" 
            :key="item" class="text-center my-4 mx-10 py-2"
            :class="selectedQual(item) ? 'primary': ''"
            @click="selectQual(item)"
          >
            {{ item }}
          </v-card>
          <v-row>
            <v-btn color="primary" @click="prevQual" outlined>Prev</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="saveQual" outlined>Save</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="nextQual" outlined>Next</v-btn>
          </v-row>
        </div>
        <div v-else class="mx-10">
          <h2 class="primary--text text-center">Copy Entries</h2>
          <v-select v-model="copyUser"
            :items="poolObject.poolMembers" item-value="userId"
            :item-text="item => item.userFName + ' ' + item.userLName"
            label="Copy Entries From"
          >
          </v-select>
          <v-row>
            <v-btn color="success" @click="copyEntry=false" outlined>Cancel</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="copyUserEntry" outlined>Copy</v-btn>
          </v-row>
        </div>
      </div>
    </v-col>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import axios from 'axios'

export default {
  name: 'pool-entry',
  computed: {
    ...mapGetters([
      'memberPools', 'memberPoolsLoaded',
      'bonusPointList', 'bonusPointLoaded',
      'poolEntryList', 'poolEntryLoaded',
      'poolKOEntryList', 'poolKOEntryLoaded',
      'bonusPointList', 'bonusPointLoaded',
      'groupGames', 'groupGamesLoaded',
      'tourGroups', 'tourGroupsLoaded', 'userProfile'
    ]),
    poolPastEndDate: function() {
      if (!this.poolObject) {
        return false
      }
      var d = new Date()
      var e = new Date(this.poolObject.entryEndDate)
      return (e >= d) ? false : true
    },
  },
  watch: {
    poolEntryLoaded: function() {
      if (this.poolEntryList.length == 0) {
        return
      }
      this.entryList.splice(0)
      var i=0;
      for (i=0; i<this.poolEntryList.length; i++) {
        var entry = {
          gameId: this.poolEntryList[i].gameId,
          gameDate: this.poolEntryList[i].gameDate,
          gameVenue: this.poolEntryList[i].gameVenue,
          gameNum: this.poolEntryList[i].gameNum,
          memberA: this.poolEntryList[i].memberA,
          memberB: this.poolEntryList[i].memberB,
          oddA: this.poolEntryList[i].oddA,
          oddB: this.poolEntryList[i].oddB,
          resultEntry: this.poolEntryList[i].resultEntry,
          bonusEntry: this.poolEntryList[i].bonusEntry ? this.poolEntryList[i].bonusEntry.slice() : []
        }
        this.entryList.push(entry)
      }
      //while (!this.bonusPointLoaded) ;
      this.bonusUsed.splice(0)
      for (i=0; i< this.poolObject.bonusUsed.length; i++) {
        let bp = this.poolObject.bonusUsed[i]
        this.bonusUsed.push(this.bonusPointList.find(elem => elem.bonusId == bp))
      }
    },
    groupGamesLoaded: function() {
      if (this.poolEntryList.length > 0) {
        return
      }
      if (this.groupGames.length == 0) { 
        return
      }
      this.entryList.splice(0)
      var i=0
      //while (!this.bonusPointLoaded) ;
      this.bonusUsed.splice(0)
      for (i=0; i< this.poolObject.bonusUsed.length; i++) {
        let bp = this.poolObject.bonusUsed[i]
        this.bonusUsed.push(this.bonusPointList.find(elem => elem.bonusId == bp))
      }
      for (i=0; i<this.groupGames.length; i++) {
        var entry = {
          gameId: this.groupGames[i].gameId,
          gameDate: this.groupGames[i].gameDate,
          gameVenue: this.groupGames[i].gameVenue,
          gameNum: this.groupGames[i].gameNum,
          memberA: this.groupGames[i].memberA,
          memberB: this.groupGames[i].memberB,
          oddA: this.groupGames[i].oddA,
          oddB: this.groupGames[i].oddB,
          resultEntry: ' ',
          bonusEntry: []
        }
        var j=0
        for (j=0; j<this.bonusUsed.length; j++) {
          var bonus = {
            id: this.bonusUsed[j].bonusId,
            entry: ' '
          }
          entry.bonusEntry.push(bonus)
        }
        this.entryList.push(entry)
      }
    }
  },
  data: () => ({
    entryChanged: false,
    copyEntry: false,
    poolId: '',
    poolObject: null,
    gameEntry: true,
    entryList: [],
    koQList: [],
    bonusUsed: [],
    koNumbers: [1, 2, 4, 8, 16, 32, 64, 128, 256],
    koValues: ['Winner', 'Finalists', 'Semi-Finalists', 'Quarter-Finalists', 
              'Round of 16', 'Round of 32', 'Round of 64', 'Round of 128', 'Round of 256'],
    koIndex: -1,
    copyUser: '',
  }),
  created() {
    this.$store.dispatch('getMemberPools')
  },
  methods: {
    convDate(inDate) {
      return inDate.substring(0, 10)
    },
    checkForChanges() {
      if (this.entryChanged) {
        return (confirm("Changes have been made.  Do you want to move without saving?"))
      } else {
        return true
      }
    },
    poolChange() {
      if (!this.checkForChanges()) {
        this.poolId = this.poolObject.poolId
        return
      }
      this.poolObject = this.memberPools.find(elem => elem.poolId == this.poolId)
      this.$store.dispatch('getBonusPointList', this.poolObject.sportId)
      this.$store.dispatch('getGroupGamesByTour', this.poolObject.tournamentId)
      this.$store.dispatch('getPoolEntryList', this.poolId)
      this.$store.dispatch('getPoolKOEntryList', this.poolId)
      this.$store.dispatch('getTourGroups', this.poolObject.tournamentId)
    },
    selectTeam(index, team) {
      this.entryChanged = true
      if (this.entryList[index].resultEntry == ' ') {
        this.entryList[index].resultEntry = team
      } else if (this.entryList[index].resultEntry == 'X') {
        this.entryList[index].resultEntry = (team == 'A') ? 'B' : 'A'
      } else {
        if (team != this.entryList[index].resultEntry) {
          this.entryList[index].resultEntry = 'X'
        } else {
          this.entryList[index].resultEntry = ' '
        }
      }
    },
    goBack() {
      if (!this.checkForChanges()) {
        return
      }
      this.$router.go(-1)
    },
    saveGames() {
      const token = this.$store.getters.authToken
      const header = { 'Content-type': 'application/json', 'x-auth': token }
      for (var i=0; i<this.entryList.length; i++) {
        var entryObj = {
          poolId: this.poolId,
          gameId: this.entryList[i].gameId,
          resultEntry: this.entryList[i].resultEntry,
          bonusEntry: this.entryList[i].bonusEntry
        }
        axios.post('/api/userPoolEntry', JSON.stringify(entryObj), { headers: header })
        .catch(error => {
          alert(error.response.data.err)
          return
        })
      }
      this.entryChanged = false
    },
    setupQList() {
      this.koQList.splice(0)
      if (this.poolKOEntryList.length > 0) {
        let index = this.poolKOEntryList.findIndex(elem => elem.koLevel == this.koNumbers[this.koIndex])
        if (index >= 0) {
          this.koQList = this.poolKOEntryList[index].koLevelEntry.slice()
        } 
      }
    },
    gameNext() {
      if (!this.checkForChanges()) {
        return
      }
      this.koQList.splice(0)
      this.koIndex = Math.log2(this.poolObject.knockoutStartLevel)
      this.setupQList()
      this.entryChanged = false
      this.gameEntry = false
    },
    selectedQual(team) {
      let found =  this.koQList.findIndex(elem => elem == team )
      return (found == -1) ? false : true
    },
    selectQual(team) {
      let index = this.koQList.findIndex(elem => elem == team)
      if (index == -1) {
        if (this.koQList.length == this.koNumbers[this.koIndex]) {
          return
        }
        this.koQList.push(team)
      } else {
        this.koQList.splice(index, 1)
      }
      this.entryChanged = true
    },
    prevQual() {
      if (!this.checkForChanges()) {
        return
      }
      if (this.koNumbers[this.koIndex] == this.poolObject.knockoutStartLevel) {
        this.gameEntry = true
      } else {
        this.koIndex = this.koIndex + 1
        this.setupQList()
      }
      this.entryChanged = false
    },
    saveQual() {
      const token = this.$store.getters.authToken
      const header = { 'Content-Type': 'application/json', 'x-auth': token }
      var qObj = {
        poolId: this.poolId,
        koLevel: this.koNumbers[this.koIndex],
        koLevelEntry: this.koQList
      }
      axios.post('/api/userPoolKOEntry', JSON.stringify(qObj), { headers: header })
      .then(() => {
        this.$store.dispatch('getPoolKOEntryList', this.poolId)
      })
      .catch(error => {
        alert(error.response.data.err)
        return
      })
      this.entryChanged = false
    },
    nextQual() {
      if (!this.checkForChanges()) {
        return
      }
      if (this.koIndex == 0) {
        return
      } else {
        this.koIndex = this.koIndex - 1
        this.setupQList()
      }
      this.entryChanged = false
    },
    copyUserEntry() {
      if (this.copyUser == '') {
        alert('Select a Member to copy entries from')
        return
      }
      if (this.copyUser === this.userProfile.userId) {
        alert('You cannot choose your own Name')
        return
      }
      const token = this.$store.getters.authToken
      const header = { 'Content-Type': 'application/json', 'x-auth': token }
      var copyEntry = {
        poolId: this.poolId,
        fromUser: this.copyUser,
      }
      axios.post('/api/userPoolEntryCopy', JSON.stringify(copyEntry), { headers: header })
      .then(() =>  {
        alert('Entries Copied')
        //this.$store.dispatch('getGroupGamesByTour', this.selectedPool.tournamentId)
        //this.$store.dispatch('getTourGroups', this.selectedPool.tournamentId)
        this.$store.dispatch('getPoolEntryList', this.poolId)
        this.$store.dispatch('getPoolKOEntryList', this.poolId)
        this.copyEntry = false
      })
      .catch(error => {
        alert(error.response.data.err)
      })
    }
  }
}
</script>